export class Submittal {
  static addlAssignee(submittal, user) {
    return submittal.submittal_addl_assignees.find(
      (addlAssignee) => addlAssignee.assignee_id === user.id
    );
  }

  static assignee(submittal, user) {
    return (
      submittal.assignee_id === user.id || !!this.addlAssignee(submittal, user)
    );
  }

  static responded(submittal, user) {
    const addlAssignee = this.addlAssignee(submittal, user);
    return (
      submittal.responded_by_id === user.id ||
      !!(addlAssignee && addlAssignee.stamp_action)
    );
  }

  static readOnly(submittal, user) {
    return (
      !this.assignee(submittal, user) ||
      !!submittal.closed ||
      this.responded(submittal, user)
    );
  }
}



// WEBPACK FOOTER //
// ./src/domain/submittal.js